import { STATUS_CODE } from '~/constants'
import { ENDPOINT } from './endPoint'
import request from './request'

// API DATA FOOD COURT BY Slug
export const getDataFoodCourtApi = async (foodCourtSlug) => {
  const URL = `${ENDPOINT.FOOD_COURTS}/${foodCourtSlug}`

  try {
    const { data, status } = await request().get(URL)
    if (status === STATUS_CODE.NUM_SUCCESS) {
      return {
        isSuccess: true,
        data: data || {},
      }
    }
  } catch (error) {
    return {
      isSuccess: false,
      data: {},
      error_message: error.response?.data?.message,
    }
  }
}

// API SERVING REQUESTS MÀN HÌNH ORDER HISTORY
export const getDataServingRequestApi = async () => {
  try {
    const { data, status } = await request().get(ENDPOINT.SERVING_REQUESTS)

    if (status === STATUS_CODE.NUM_SUCCESS) {
      return {
        isSuccess: true,
        data: data || {},
      }
    }
  } catch (error) {
    return {
      isSuccess: false,
      data: {},
      error_message: error.response?.data?.message,
    }
  }
}

// Hàm xử lý update số điện thoại người dùng để phục vụ cho việc gửi sms
export const updatePhoneNumberApi = async (phone) => {
  try {
    const { status } = await request().post(ENDPOINT.UPDATE_PHONE_NUMBER, {
      phone,
    })

    if (status === STATUS_CODE.NUM_SUCCESS) {
      return {
        isSuccess: true,
      }
    }

    throw new Error('')
  } catch (error) {
    return {
      isSuccess: false,
      error_message: error.response?.data?.message,
    }
  }
}

// Hàm tạo short link
export const createShortLinkApi = async (metadata) => {
  try {
    const { status } = await request().post(ENDPOINT.CREATE_SHORT_LINK, {
      short_link: {
        metadata,
      },
    })

    if (status === STATUS_CODE.NUM_SUCCESS) {
      return {
        isSuccess: true,
      }
    }

    throw new Error('')
  } catch (error) {
    return {
      isSuccess: false,
      error_message: error.response?.data?.message,
    }
  }
}

// Hàm lấy chi tiết short link
export const getDetailShortLinkApi = async (short_link_id) => {
  const URL = `${ENDPOINT.CREATE_SHORT_LINK}/${short_link_id}`

  try {
    const { data, status } = await request().get(URL)

    if (status === STATUS_CODE.NUM_SUCCESS) {
      return {
        isSuccess: true,
        data: data.short_link || {},
      }
    }
  } catch (error) {
    return {
      isSuccess: false,
      data: {},
      error_message: error.response?.data?.message,
    }
  }
}
